import styled, { createGlobalStyle } from 'styled-components'

export const MobileContainerPadding = createGlobalStyle`
  @media (max-width: 768px) {
    .row.px-0.mx-0 > .container {
      padding: 98px 16px;
    }
  }
`

export const OpportunityListGlobalStyle = createGlobalStyle`
  .hub-startup-opportunity-list-root {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    align-self: stretch;
    box-sizing: border-box;

    @media (max-width: 768px) {
      padding: 0 16px;
    }
  }
`

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  align-self: stretch;
  box-sizing: border-box;
`

export const PageHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 1.5rem;
`

export const SearchSection = styled.div`
  width: 50%;
  max-width: 50%;
  margin-bottom: 2rem;

  @media (max-width: 992px) {
    width: 100%;
    max-width: 100%;
  }
`

export const EmptySearchMessage = styled.p`
  text-align: center;
  color: #6b7280;
  margin: 2rem 0;
`

export const OpportunityList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 1rem;
  width: 100%;
`
